import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "w-full flex" };
import { InvoiceService, UrlType } from '@/services/InvoiceService';
import { Copy01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UITextSmRegular, useNotification } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PaymentLinkUrl',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const { t } = useI18n();
        const props = __props;
        const paymentUrl = ref();
        const loading = ref(false);
        const notification = useNotification();
        const onCopyPaymentLink = async () => {
            let url = '';
            const item = props.item;
            if (paymentUrl.value) {
                url = paymentUrl.value;
            }
            else {
                // get payment url from api
                try {
                    loading.value = true;
                    const { data } = await InvoiceService.generateUrl({
                        id: item._id,
                        type: UrlType.PAYMENT_LINK,
                        shortUrl: false,
                    });
                    url = data.url;
                    paymentUrl.value = url;
                }
                catch (err) {
                    console.error(err);
                }
                finally {
                    loading.value = false;
                }
            }
            navigator.clipboard.writeText(url);
            notification.success({
                content: t('dashboard.paymentlinkCopiedSucessfully'),
                duration: 3000,
                keepAliveOnHover: true,
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UITextSmRegular), { class: "text-ellipsis truncate select-none md:w-20 lg:w-48 xl:w-60" }, {
                    default: _withCtx(() => [
                        _createTextVNode(" /" + _toDisplayString(__props.item?._id), 1)
                    ]),
                    _: 1
                }),
                _createVNode(_unref(UIButton), {
                    id: "copy-btn",
                    disabled: !__props.item.active,
                    loading: loading.value,
                    tertiary: "",
                    circle: "",
                    onClick: onCopyPaymentLink
                }, {
                    icon: _withCtx(() => [
                        (!loading.value)
                            ? (_openBlock(), _createBlock(_unref(Copy01Icon), {
                                key: 0,
                                class: "w-4 h-4"
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["disabled", "loading"])
            ]));
        };
    }
});
